import React from 'react'
import moment from 'moment-timezone'
import styled from 'styled-components'

import { Rating } from '~/components'
import Icon from '~/truck/icon'
import theme from '~/truck/theme'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${theme.spacing.relaxed}px;

  > span:first-of-type {
    margin-bottom: ${theme.spacing.cozy}px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.gray};
    padding-bottom: ${theme.spacing.relaxed}px;
  }
`

const Customer = styled.div`
  display: flex;
  justify-content: space-between;

  > div {
    display: flex;
    margin-bottom: ${theme.spacing.cozy}px;

    > :first-child {
      margin-right: ${theme.spacing.cozy}px;
    }
  }
`

const ProductRating = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: ${theme.spacing.compact * 3}px;

  svg {
    margin-right: ${theme.spacing.compact}px;
  }
`

const ProductReview = props => {
  const { title, comment, rating, isVerified, updatedAt, reviewer } = props

  const { fullName } = reviewer

  return (
    <Container>
      <Customer>
        <div>
          <Icon type="profile" color="black" size="sm" interactive={false} />
          <span className="text-xs font-semibold">{fullName}</span>
        </div>
        <span className="text-xs font-semibold">{moment(updatedAt).format('DD/MM/YYYY')}</span>
      </Customer>
      <ProductRating>
        <Rating initialRating={rating} />
        {isVerified && (
          <>
            <label className="mx-2 text-neutral-300"> • </label>
            <Icon type="check" color="success" size="sm" interactive={false} />
            <span className="text-xs font-semibold text-success">Compra Verificada</span>
          </>
        )}
      </ProductRating>
      {title && <span className="font-semibold">{title}</span>}
      {comment && <span className="whitespace-pre-line">{comment}</span>}
    </Container>
  )
}

export default ProductReview
